
  import {Component, Vue} from "vue-property-decorator";
  import AuditTabPane from "../components/AuditTabPane.vue";
  import {AuditUserLogType, PayOrderType, RefundLogDto} from "@/api/appService";
  import api from '@/api/index'

  @Component({name:'AuditTabOfRefund',
    components: {AuditTabPane}
  })
  export default class AuditTabOfRefund extends Vue{

    getHostType(dto:any){
      const refundDto  = dto as RefundLogDto;
      return this.convertPayOrderTypeToAuditUserLogType(refundDto.payOrderType!);
    }

    audit(){
      return api.refundLog.audit;
    }

    fetchData(){
      return api.refundLog.getMyAll;
    }


    formatPayOrderType(payOrderType:PayOrderType){
      if(payOrderType === PayOrderType.Activity){
        return '活动';
      } else if(payOrderType === PayOrderType.Card){
        return '会员卡';
      } else if(payOrderType === PayOrderType.DiffCard){
        return '补差卡';
      } else {
        return payOrderType;
      }
    }

    handleCountChange(value:number){
      this.$emit('count-changed',value);
    }


    convertPayOrderTypeToAuditUserLogType(payOrderType:PayOrderType){
      switch (payOrderType ) {
        case PayOrderType.Activity:
          return AuditUserLogType.ActivityRefund;
        case PayOrderType.Card:
          return AuditUserLogType.UserCardRefund;
        case PayOrderType.DiffCard:
          return AuditUserLogType.UserDiffCardRefund;
      }
    }
  }
